import { Divider, Input, Checkbox, Select, Form, Row, Col, Button, Alert } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { providerRegConfig } from './formConfig';

const
config = providerRegConfig,
{ key } = config,
{ generateFormItem, generateInputComponent, generateOptionFromCommonData, generateStateOptionsFromCommonData, setMaxWidth } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils,
{ IconPopover } = ssCommonUtils,
FormItem = Form.Item,
EMAIL_FIELD = 'emailAddress',
VERIFY_EMAIL = 'verifyEmail',
VERIFY_MESSAGE = 'Email addresses must match',
SCHOOL_NAME = 'schoolName',
SCHOOL_STATE = 'schoolState',
popoverText = {
    PROVIDER_TYPE: {
        header: 'FTSP Provider Type',
        contents: (
            <div>
                {'Providers are registered within the FTSP system with a Provider type. This '}
                {'Provider type is based on the Code of Federal Regulations Title 14 (14CFR61, '}
                {'14CFR121, 14CFR141, 14CFR142) and FAA Regulations.'}
                <br/><br/>

                {'A '}
                <span style={{ fontWeight: 'bold' }}>
                    {'Part 141'}
                </span>
                {' provider is a certificated pilot school that operates with a pilot school '}
                {'certificate or provisional pilot school certificate issued under this part. '}
                {'Refer to 14CFR141.33, 141.35, 141.36, and/or 141.37 for more information on '}
                {'Part 141 requirements.'}
                <br/><br/>

                {'A '}
                <span style={{ fontWeight: 'bold' }}>
                    {'Part 142'}
                </span>
                {' provider is a certificated training center that operates with a training center '}
                {'certificate or provisional training center certificated issued under this part. '}
                {'Training center means an organization governed by the applicable requirements of '}
                {'this part that provides training, testing, and checking under contract or other '}
                {'arrangement to airmen subject to the requirements of the CFR chapter. Refer to '}
                {'14CFR142.47, 141.49, and/or 141.55 for more information on Part 142 requirements.'}
                <br/><br/>

                {'A '}
                <span style={{ fontWeight: 'bold' }}>
                    {'Part 61'}
                </span>
                {' provider is a person who holds a valid ground instructor certificate issued under '}
                {'14CFR part 61 or part 143, holds a current flight instructor certificate issued under '}
                {'14CFR part 61, or is authorized by the Administrator to provide ground training or '}
                {'flight training under 14CFR when conducting ground training or flight training in '}
                {'accordance with the privileges, limitations, and authority. Refer to 14CFR61.183 for '}
                {'more information on Part 61 requirements.'}
                <br/><br/>

                {'An '}
                <span style={{ fontWeight: 'bold' }}>
                    {'Individual CFI'}
                </span>
                {' provider is an individual Certified Flight Instructor who is authorized by the FAA '}
                {'to instruct pilot courses.'}
                <br/><br/>

                {'An '}
                <span style={{ fontWeight: 'bold' }}>
                    {'Air Carrier'}
                </span>
                {' provider is a pilot school that possesses a FAA Air Carrier certificate. Refer to '}
                {'14CFR121.412 for more information on Air Carrier requirements.'}
                <br/><br/>

                {'If you have additional questions regarding the FAA provider type: '}
            </div>
        )
    },
    FAA_CERT: {
        header: 'FAA Certification or Satellite Designator',
        contents: (
            <div>
                {' The FAA certification number identified with the Provider type selected below should '}
                {'be used when registering as a Provider Administrator within the FTSP online portal.'}
                <br/><br/>

                {'For a '}
                <span style={{ fontWeight: 'bold' }}>
                    {'Part 141 or Part 142,'}
                </span>
                {' the FAA school certification number should be entered for the FAA certification number '}
                {'by the Provider Administrator.'}
                <br/><br/>

                {'For a '}
                <span style={{ fontWeight: 'bold' }}>
                    {'Part 61,'}
                </span>
                {' the Provider Administrator should be a CFI and their CFI certification number should '}
                {'be listed as the FAA certification number.'}
                <br/><br/>

                {'For an '}
                <span style={{ fontWeight: 'bold' }}>
                    {'Individual CFI,'}
                </span>
                {' the instructor must sign up as a Provider Administrator using their FAA CFI certification '}
                {'number as the FAA certification number.'}
                <br/><br/>

                {'For an '}
                <span style={{ fontWeight: 'bold' }}>
                    {'Air Carrier,'}
                </span>
                {' the FAA Air Carrier certificate number should be entered for the FAA certification '}
                {'number by the Provider Administrator.'}
                <br/><br/>

                {'If you have additional questions regarding the FAA certification number: '}
            </div>
        )
    },
    APPLICABLE_NOTICES: {
        header: 'Applicable Notices',
        contents: (
            <div>
                <span style={{ fontWeight: 'bold' }}>
                    {'PRIVACY ACT NOTICE \n'}
                </span>
                <br/><br/>

                {'This notice is for the information of persons covered by the Privacy Act. '}
                {'The Privacy Act covers individuals who are U.S. citizens and permanent '}
                {'resident non-U.S. citizen(s) and non-U.S. national(s).'}
                <br/><br/>

                {'The Transportation Security Administration is authorized to collect the '}
                {'information requested on this form by Section 612 of Vision 100 - Century '}
                {'of Aviation Reauthorization Act (49 U.S.C. \§ 44939). The information '}
                {'collected on this form, including the candidates\' social security account '}
                {'numbers, will be used, primarily, to assess possible risks to aviation or '}
                {'national security posed by candidates seeking training in the operation '}
                {'of aircraft of any type. Submission of the information sought on this form, '}
                {'including the request for applicants\' social security account numbers, is '}
                {'voluntary. However, if the information requested is not submitted, the '}
                {'Transportation Security Administration will be unable to conduct the risk '}
                {'assessment required under the Vision 100 - Century of Aviation Reauthorization '}
                {'Act. Consequently, the candidate/training provider may be denied the '}
                {'opportunity to pursue/conduct the training requested. Information you submit '}
                {'regarding your registration or request for training may be disclosed by the '}
                {'Government only in accordance with the provisions of the Privacy Act.'}
                <br/><br/>

                <span style={{ fontWeight: 'bold' }}>
                    {'CONSENT, AUTHORIZATION AND NOTICE'}
                </span>
                <br/><br/>

                {'Pursuant to 15 U.S.C. § 7001, it is hereby requested that you consent to the '}
                {'use of electronic records exclusively for purposes of the submission and '}
                {'processing of this form and the accompanying waivers. This is necessary in '}
                {'order to register you as a provider of flight services and to quickly and '}
                {'effectively process requests from non-U.S. citizen(s) and non-U.S. national(s) or other designated individuals who '}
                {'seek training from you. In addition, you are asked to consent to such disclosures '}
                {'of information as are necessary to conduct the required risk assessment/investigation '}
                {'or are otherwise deemed necessary in the interests of national security or law enforcement.'}
                <br/><br/>

                {'In order to use this system and to access any record submitted by you which is '}
                {'maintained on the system, you must have access to a computer through which you '}
                {'can access the internet. In addition, you must have an electronic mail address. '}
                {'You will be apprised by electronic mail of any changes to the system requirements '}
                {'necessary in order to access the information you have submitted.'}
                <br/><br/>

                <span style={{ fontWeight: 'bold' }}>
                    {'CONSENT TO ELECTRONIC RECORDS'}
                </span>
                <br/><br/>

                {'I hereby consent to the use of electronic records for all purposes in connection '}
                {'with this registration and accompanying waivers. I understand that this form and '}
                {'the waivers attached are not available on paper or in non-electronic form. I further '}
                {'understand that I may withhold or withdraw my consent to the use of electronic records '}
                {'by refusing to submit this form, or by subsequently notifying the Transportation Security '}
                {'Administration in writing of my decision to withdraw my consent at the following address: '}
                <br/><br/>

                {'Flight Training Security Program'}<br/>
                {'601 S. 12th Street'}<br/>
                {'Arlington, VA 20598-6019'}<br/><br/>

                {'I understand that any withdrawal of consent will be effective when processed by the '}
                {'Transportation Security Administration.'}
                <br/><br/>

                {'I understand that my refusal to authorize the use of electronic records or my '}
                {'subsequent revocation of such authorization may result in the denial or delay in '}
                {'processing of any request submitted by a candidate seeking training with me.'}
                <br/><br/>

                {'Non-electronic copies of the records are not provided by the Transportation Security '}
                {'Administration. Nevertheless, persons submitting this form may print out copies of their '}
                {'submissions and retain them in paper form.'}
                <br/><br/>

                {'I certify that I am the training provider submitting this form, or a duly authorized '}
                {'representative of the provider. I understand that this is a legally binding document; '}
                {'that my assent to this document constitutes an electronic signature; and that false '}
                {'statements by me in these submissions are violations of federal law and may lead to criminal '}
                {'prosecution or other legal action.'}
            </div>
        )
    }
};

export default class ProviderRegForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = { alertOrgConflict: false }
    }

    componentDidMount() {
        const { getHomeFsdoLocations, loadAllSchools } = this.props.services;
        getHomeFsdoLocations();
        loadAllSchools();
    }

    static getDerivedStateFromProps(nextProps) {
        // WARNING: THIS DOES NOT RETURN IF 'FALSE'.
        // According to the React API, this static function is REQUIRED
        // to return EVERY SINGLE TIME it is executed. This currently causes
        // an execution error. Either fix or remove. Read React API to learn
        // about this function.
        if(nextProps.state.registrationForm[key]) {
            const
            { registrationForm } = nextProps.state,
            form = registrationForm[key];

            let found = false;
            if(form[SCHOOL_NAME] && form[SCHOOL_STATE]) {
                nextProps.state.provider.schoolList.forEach(record => {
                    if(
                        (record.schoolName.localeCompare(form[SCHOOL_NAME], 'en', { sensitivity: 'base' }) == 0) &&
                        (record.stateCd.localeCompare(form[SCHOOL_STATE], 'en', { sensitivity: 'base' }) == 0)
                    ) found = true;
                });
            }

            return ({ alertOrgConflict: found });
        }
    }

    componentDidUpdate(prevProps) {
        
        const
        { state, services } = this.props,
        { registrationForm, provider } = state,
        { key } = config,
        form = registrationForm[key],
        prevForm = prevProps.state.registrationForm[key],
        { storeForm } = services;
        if(!ssCommonUtils.simpleObjectCompare(prevForm, form)) {
            const formState = validateForm(form, config, true);
            if (!provider.invalidEmailError && !provider.faaCertError) storeForm(key, formState);
            this.setState({ isValid:
                (provider.invalidEmailError || provider.faaCertError) ? false : this.verifyEmail(this.props, true) && validateSubForm(formState)
            });
        }
    }

    getButton() {
        const
        { services, state } = this.props,
        { registrationForm } = state,
        { registration } = this.props.state.app.request;

        let props = {
            size: 'small',
            type: 'primary',
            icon: 'check-circle-o',
            onClick: () => {
                this.setState({ loading: true });
                services.toggleProviderCaptchaView();
            },
            style: {
                width: '95%',
                marginTop: '25px',
                textAlign: 'center',
                minWidth: '200px',
                borderRadius: '20px'
            }
        }

        if(registrationForm[key] && registrationForm[key].agree) {
            const formState = validateForm(registrationForm[key], providerRegConfig);
            if(validateSubForm(formState) && this.verifyEmail(this.props, false)) {
                return (<Button loading={registration.status === 'pending'} {...props}>{'Submit Registration'}</Button>);
            }
        }

        return (<Button {...props} disabled='disabled'>{'Submit Registration'}</Button>);
    }


    verifyEmail(nextProps, updateState) {
        const
        { registrationForm } = nextProps.state,
        form = registrationForm[key];
        if(form[VERIFY_EMAIL] || form[EMAIL_FIELD]) {
            if(form[VERIFY_EMAIL] === form[EMAIL_FIELD]) {
                if(updateState) this.setEmailVerificationError(false);
                return true;
            }
            if(updateState) this.setEmailVerificationError(true);
            return false;
        } else return true;
    }

    setEmailVerificationError(inError) {
        const
        { services } = this.props,
        { storeFormField } = services;
        storeFormField(key, `${VERIFY_EMAIL}_help`, inError ? VERIFY_MESSAGE : '');
        storeFormField(key, `${VERIFY_EMAIL}_status`, inError ? 'error' : 'success');
    }

    render() {
        const
        { services, state } = this.props,
        { registrationForm, commonData, provider } = state,
        { lookupData, geoData, textData } = commonData,
        form = registrationForm[key],
        { storeForm, storeFormField } = services,
        { fsdoLocations } = state.app.registration;

        let locations = fsdoLocations === null ? [] : fsdoLocations;

        let fsdoEmail, fsdoPhone, helpText;
        if(textData.textDataStore['CINFO']){
            fsdoEmail = (
                <span style={{ fontWeight: 'bold' }}>
                    {textData.textDataStore['CINFO'].p[0].text}
                </span>
            ),
            fsdoPhone = (
                <span style={{ fontWeight: 'bold' }}>
                    {textData.textDataStore['CINFO'].p[1].text}
                </span>
            );
        }

        helpText = fsdoEmail == null || fsdoPhone == null ? null : (
            <div>
                {'Please Contact the FTSP Help Desk at '}
                {fsdoEmail}
                {' or '}
                {fsdoPhone}
                {'.'}
            </div>
        );

        return (
            <div>
                {!this.state.alertOrgConflict ? null : (
                    <Alert type='warning' message={`WARNING: You have entered information that matches and existing school: ${form[SCHOOL_NAME]} (${form[SCHOOL_STATE]})`} />
                )}
                <Form onFocus={() => {
                    if (provider.invalidEmailError) {
                        services.toggleInvalidProviderEmailError();
                    }
                    else if (provider.faaCertError){
                        services.toggleProviderFAACertError();
                    }
                }}>
                    <div className='home-prov-reg-section'>
                        <span className='home-prov-reg-section-title'>
                            {'Personal Information'}
                        </span>
                        <Divider type='horizontal' style={{ margin: '5px 0px' }} />
                    </div>
                    <Row gutter={10}>
                        <Col span={8}>
                            <FormItem {...generateFormItem('firstName', config, form)}>
                                <Input {...setMaxWidth(generateInputComponent('firstName', config, true, form, storeFormField, storeForm))}/>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem {...generateFormItem('middleName', config, form)}>
                                <Input {...setMaxWidth(generateInputComponent('middleName', config, true, form, storeFormField, storeForm))}/>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem {...generateFormItem('lastName',  config, form)}>
                                <Input {...setMaxWidth(generateInputComponent('lastName', config, true, form, storeFormField, storeForm))}/>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={10}>
                        <Col span={8}>
                            <FormItem {...generateFormItem('phoneNumber',  config, form)}>
                                <Input {...setMaxWidth(generateInputComponent('phoneNumber', config, true, form, storeFormField, storeForm))}/>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem {...generateFormItem('emailAddress', config, form)}>
                                <Input {...setMaxWidth(generateInputComponent('emailAddress', config, true, form, storeFormField, storeForm))} />
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem {...generateFormItem('verifyEmail', config, form)}>
                                <Input {...setMaxWidth(generateInputComponent('verifyEmail', config, true, form, storeFormField, storeForm))}/>
                            </FormItem>
                        </Col>
                    </Row>
                    <div className='home-prov-reg-section' style={{ marginTop: '20px' }}>
                        <span className='home-prov-reg-section-title'>
                            {'Flight Training Provider Information'}
                        </span>
                        <Divider type='horizontal' style={{ margin: '5px 0px' }} />
                    </div>
                    <Row gutter={10}>
                        <Col span={8}>
                            <FormItem {...generateFormItem('schoolName', config, form)}>
                                <Input {...setMaxWidth(generateInputComponent('schoolName', config, true, form, storeFormField, storeForm))}/>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem {...generateFormItem('schoolType', config, form)}>
                                <Select {...setMaxWidth(generateInputComponent('schoolType', config, true, form, storeFormField, storeForm))}>
                                    {generateOptionFromCommonData(lookupData.lookupDataStore['SCHOOL_TYPE_CD'])}
                                </Select>
                            </FormItem>
                            <IconPopover
                                noTitle
                                placement='right'
                                title='Help'
                                header={popoverText['PROVIDER_TYPE'].header}
                                style={{ position: 'absolute', top: '0px', left: '184px' }}
                                iconStyle={{ fontSize: '13px', fontWeight: 'bold' }}
                            >
                                {popoverText['PROVIDER_TYPE'].contents}
                                <div>
                                    {helpText}
                                </div>
                            </IconPopover>
                        </Col>
                        <Col span={8}>
                            <FormItem {...generateFormItem('faaCert', config, form)}>
                                <Input {...setMaxWidth(generateInputComponent('faaCert', config, true, form, storeFormField, storeForm))}/>
                            </FormItem>
                            <IconPopover
                                noTitle
                                title='Help'
                                placement='right'
                                header={popoverText['FAA_CERT'].header}
                                style={{ position: 'absolute', top: '0px', left: '242px' }}
                                iconStyle={{ fontSize: '13px', fontWeight: 'bold' }}
                            >
                                {popoverText['FAA_CERT'].contents}
                                <div>
                                    {helpText}
                                </div>
                                {provider.faaCertError?<Alert message={"Duplicated FAA cert "} showIcon={true} type="error"/>: null}
                            </IconPopover>
                        </Col>
                    </Row>
                    <Row gutter={10}>
                        <Col span={8}>
                            <FormItem {...generateFormItem('schoolState', config, form)}>
                                <Select {...setMaxWidth(generateInputComponent('schoolState', config, true, form, storeFormField, storeForm))}>
                                    {generateStateOptionsFromCommonData(geoData.geoDataStore, 'USA')}
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem {...generateFormItem('fsdo', config, form)}>
                                <Select {...{...setMaxWidth(generateInputComponent('fsdo', config, true, form, storeFormField, storeForm)),optionFilterProp:'children'} }   >
                                    {generateOptionFromCommonData(locations)}
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem {...generateFormItem('agree', config, form)}>
                                <Checkbox {...setMaxWidth(generateInputComponent('agree', config, true, form, storeFormField, storeForm))}/>
                            </FormItem>
                            <IconPopover
                            placement='leftBottom'
                                title='Applicable Notices'
                                header={popoverText['APPLICABLE_NOTICES'].header}
                                style={{ position: 'absolute', top: '37px', left: '-55px', width: '100%' }}
                                iconStyle={{ fontSize: '13px', fontWeight: 'bold' }}
                            >
                                {popoverText['APPLICABLE_NOTICES'].contents}
                            </IconPopover>
                        </Col>
                    </Row>
                    <Row type='flex' justify='center' align='middle'>
                        <Col>
                            {this.getButton()}
                            {fsdoEmail == null || fsdoPhone == null ? null : (
                                <IconPopover
                                    placement='top'
                                    title='Help'
                                    header='Need help?'
                                    style={{ position: 'relative', width: '100%', left: '-76px', top: '-58px' }}
                                    iconStyle={{ fontSize: '13px', fontWeight: 'bold' }}
                                >
                                    {helpText}
                                </IconPopover>
                            )}
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
